import { Button as ShadcnButton, type ButtonProps as ShadcnButtonProps } from '@/components/ui/button'
import { cn } from '@/lib/utils'

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger' | 'dangerOutline' | 'link'

interface ButtonProps extends Omit<ShadcnButtonProps, 'variant'> {
	variant?: Variant
	fullWidth?: boolean
	uppercase?: boolean
	iconOnly?: boolean
}

const variantMap: Record<Variant, ShadcnButtonProps['variant']> = {
	primary: 'default',
	secondary: 'secondary',
	ghost: 'ghost',
	danger: 'destructive',
	link: 'link',
	dangerOutline: 'outline',
}

export function Button({ variant = 'primary', fullWidth, uppercase, iconOnly, className, ...props }: ButtonProps) {
	return (
		<ShadcnButton
			variant={variantMap[variant]}
			className={cn(
				fullWidth && 'w-full',
				uppercase && 'uppercase tracking-wide',
				variant === 'dangerOutline' && 'border-destructive text-destructive hover:bg-destructive/10 hover:text-destructive',
				iconOnly && 'p-1.5 h-auto w-auto rounded-full',
				className,
			)}
			{...props}
		/>
	)
}
